import { useMemo } from "react";
import { Title } from "../typings";
import { getMainPlotOrFirstUnit } from "./getMainPlotOrFirstUnit";

export function useTitleInformation(titles: Title[]) {
  const mainTitle = useMemo(() => getMainPlotOrFirstUnit(titles), [titles]);

  return {
    mainTitle,
    propertyId: mainTitle?.id || "",
    parcelId: mainTitle?.parcel_identifier || "",
  };
}
